<template>
  <v-select
    v-bind="$attrs"
    :items="availableItems"
    :label="label"
    v-model="selected"
    :item-text="itemText"
    item-value="ID"
    :clearable="clearable"
    :rules="rules"
    :loading="loading"
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      v-slot:[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName" />
    </template>
  </v-select>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
export default {
  name: 'select-luTrackedBillPermission',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      default: 'Tracked Bill Permission',
    },
    value: Number,
    clearable: {
      type: Boolean,
      default: false,
    },
    rules: Array,
    items: Array,
    currentUserPermissionID: {
      type: Number,
    },
  },
  data() {
    return {
      //templateFIX: if there is more than one pick one to display
      itemText: 'Description',
    }
  },
  computed: {
    ...get('luTrackedBillPermission', ['luTrackedBillPermissions', 'loading']),
    availableItems() {
      var list = []
      var fullList = []
      if (this.items) {
        fullList = this.items
        //if you have a property (like an IsActive boolean) you can change the true to filer i.e. i.IsActive
        list = this.items.filter((i) => true)
      } else {
        fullList = this.luTrackedBillPermissions
        //if you have a property (like an IsActive boolean) you can change the true to filer i.e. i.IsActive
        list = this.luTrackedBillPermissions.filter((i) => true)
      }
      list = list.filter((i) => i.IsActive)
      // if existing record make sure the previous selection is available even if no longer active
      if (this.value > 0) {
        var selectedItem = fullList.find((i) => i.ID == this.value)
        if (!list.find((i) => i.ID == this.value) && selectedItem) {
          list.push(selectedItem)
        }
      }
      if (this.currentUserPermissionID && this.currentUserPermissionID > 0) {
        if (this.currentUserPermissionID == 5) {
          list = list.filter((i) => i.ID != 1)
        }
      }
      // sort by column
      list.sort((a, b) => {
        //set the property to sort on
        var permissionOrder = [1, 2, 3, 4]
        let sort =
          permissionOrder.indexOf(a.ID) > permissionOrder.indexOf(b.ID) ? 1 : -1
        return sort
      })
      return list
    },
    selected: {
      get() {
        if (this.value) {
          return this.value
        } else {
          return null
        }
      },
      set(newValue) {
        this.$emit('change', newValue)
      },
    },
  },
  created() {
    if (!this.items) {
      this.loadLuTrackedBillPermissions()
    }
  },
  methods: {
    loadLuTrackedBillPermissions: call(
      'luTrackedBillPermission/loadLuTrackedBillPermissions'
    ),
  },
}
</script>
<style>
</style>